import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
// Context
import { FormDataContext } from 'globalState/FormDataContext';
// Import components
import InputCheckbox from 'components/shared/FormElements/Input/InputCheckbox';
import Input from 'components/shared/FormElements/Input/Input';
// import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';

const Contact = (props) => {
  const [, formDispatch] = useContext(FormDataContext); // Get the state of form data from FormDataContext
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register, handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)
  const { section, header, summary } = props;

  const [formDataState] = useContext(FormDataContext);
  const { MayorContactEmail } = formDataState.formData;
  const { MayorContactPhone } = formDataState.formData;

  // Labels used on inputs and for validation
  const checkBoxEmail = 'Email';
  const emailLabel = 'Email address';
  // Logic used to validate the email field
  const emailRegex =
    /^[\w!#$%&amp;'*+\-/=?^_`{|}~]+(\.[\w!#$%&amp;'*+\-/=?^_`{|}~]+)*@((([-\w]+\.)+[a-zA-Z]{2,4})|(([0-9]{1,3}\.){3}[0-9]{1,3}))$/; // Matches email regex on server

  // Logic used to validate fields
  const fieldValidation = (name) => {
    return register({ required: `${name} is required` });
  };

  // email validation
  const emailValidation = register({
    required: `${emailLabel} is required`,
    pattern: {
      value: emailRegex,
      message: `Enter an ${emailLabel.toLowerCase()} in the correct format`,
    },
  });

  // email input src
  const emailInputSrc = (
    <div className="wmcads-m-l-xl">
      <Input
        className="wmcads-col-1 wmcads-col-lg-3-4"
        name="emailAddress"
        label="Email address<br> For example, name@example.com"
        autocomplete="given-name"
        fieldValidation={emailValidation}
      />
    </div>
  );

  // phone input src
  const phoneInputSrc = (
    <div className="wmcads-m-l-xl">
      <Input
        className="wmcads-col-1 wmcads-col-lg-3-4"
        name="ContactPhone"
        label="Phone number<br> For example, 07700900457"
        autocomplete="given-name"
        fieldValidation={fieldValidation('Phone number')}
      />
    </div>
  );

  // Add email input when email if true
  let emailInput;
  const emailOption = document.querySelector(
    'input.wmcads-fe-checkboxes__input[name="MayorContactEmail"]:checked'
  );

  if ((emailOption && emailOption.value !== null) || MayorContactEmail === true) {
    emailInput = emailInputSrc;
  }

  // Add phone input if true
  let phoneInput;
  const phoneOption = document.querySelector(
    'input.wmcads-fe-checkboxes__input[name="MayorContactPhone"]:checked'
  );
  if ((phoneOption && phoneOption.value !== null) || MayorContactPhone === true) {
    phoneInput = phoneInputSrc;
  }

  // set the email checkbox to form data
  const emailCheck = (e) =>
    formDispatch({
      type: 'UPDATE_FORM_DATA',
      payload: { MayorContactEmail: e.target.checked },
    });

  // set the phone checkbox to form data
  const phoneCheck = (e) =>
    formDispatch({
      type: 'UPDATE_FORM_DATA',
      payload: { MayorContactPhone: e.target.checked },
    });

  // clear email if unchecked
  if (MayorContactEmail === false) {
    formDataState.formData.ContactEmail = null;
  }

  // clear phone if unchecked
  if (MayorContactPhone === false) {
    formDataState.formData.ContactPhone = null;
  }

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      <div className="wmcads-progress-indicator">
        {section}
        <h4>{header}</h4>
      </div>

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <div className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">How would you like to be contacted?</h2>
          <p>{summary}</p>
        </div>
        <InputCheckbox
          name="MayorContactEmail"
          type="checkbox"
          fieldValidation={register({
            required: false,
          })}
          labelValue={checkBoxEmail}
          handleChange={emailCheck}
        />
        {emailInput}
        <InputCheckbox
          name="MayorContactPhone"
          type="checkbox"
          fieldValidation={register({
            required: false,
          })}
          labelValue="Phone"
          handleChange={phoneCheck}
        />
        {phoneInput}
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

Contact.propTypes = {
  summary: PropTypes.string,
  section: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
};

Contact.defaultProps = {
  summary: '',
};

export default Contact;
